import React from "react";
import { Button } from "@mui/material";

interface SystemSizingToolButtonProps {
  onClick: () => void;
}

export const SystemSizingToolButton: React.FC<SystemSizingToolButtonProps> = ({
  onClick,
}) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      sx={{
        border: "1px solid #0076CE",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: "12px",
        color: "#0076CE",
        background: "transparent",
        textTransform: "none",
        padding: "8px 16px",
        minWidth: "auto",
        whiteSpace: "nowrap",
        "&:hover": {
          background: "#0076CE",
          color: "#fff",
          borderColor: "#0076CE",
        },
      }}
    >
      System Sizing Tool
    </Button>
  );
};

export default SystemSizingToolButton;
